export const NAME = 'name';
export const MOBILE_PHONE = 'mobilePhone';
export const EMAIL = 'email';
export const IS_MEMBER = 'isMember';
export const ACTION = 'action';
